import { MuiButton, MuiTypography } from '@/features/shared/material-ui';
import { CaptureClicksRichText } from '@/features/shared/RichText';
import React from 'react';
import { PrivacyConsentModalContentProps } from '../PrivacyConsentModal.interfaces';
import { usePortalCookieModalContentStyles } from './PrivacyConsentModalContent.styles';

export const PrivacyConsentModalContent = ({
  title,
  labels,
  content,
  onAcceptClick,
  onDeclineClick,
}: PrivacyConsentModalContentProps) => {
  const classes = usePortalCookieModalContentStyles();

  return (
    <section className={classes.root} data-testid="portal-cookie-modal-content">
      {title && (
        <MuiTypography variant="h5" className={classes.title}>
          {title}
        </MuiTypography>
      )}
      {content && <CaptureClicksRichText className={classes.content} content={content} />}
      <div className={classes.actions}>
        <MuiButton
          className="action-button"
          onClick={onDeclineClick}
          data-datalayer-cta-type
          data-datalayer-action="decline"
        >
          {labels?.decline || 'Decline'}
        </MuiButton>
        <MuiButton
          className="action-button"
          onClick={onAcceptClick}
          data-datalayer-cta-type
          data-datalayer-action="accept"
        >
          {labels?.accept || 'Accept'}
        </MuiButton>
      </div>
    </section>
  );
};
